import three from "./../sounds/three.ogg";
import two from "./../sounds/two.ogg";
import one from "./../sounds/one.ogg";
import four from "./../sounds/four.ogg";
import five from "./../sounds/five.ogg";
import six from "./../sounds/six.ogg";
import seven from "./../sounds/seven.ogg";
import eight from "./../sounds/eight.ogg";
import nine from "./../sounds/nine.ogg";
import ten from "./../sounds/ten.ogg";

export const numbers = [
    {
      title: "one",
      polish: "jeden",
      image:
        "https://images.unsplash.com/photo-1521200039080-c704f509c0c2?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
        sounds: one,
    },
    {
      title: "two",
      polish: "dwa",
      image:
        "https://images.unsplash.com/photo-1577228232276-da3cbc016be0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
        sounds: two,
    },
    {
      title: "three",
      polish: "trzy",
      image:
        "https://images.unsplash.com/photo-1572324755260-ec8c3e7fae29?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=474&q=80",
        sounds: three,
    },
    {
      title: "four",
      polish: "cztery",
      image:
        "https://images.unsplash.com/photo-1561637878-7bdf3fcdb798?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=889&q=80",
        sounds: four,
    },
    {
      title: "five",
      polish: "pięć",
      image:
        "https://images.unsplash.com/photo-1562791241-122a7c501434?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mnx8Zml2ZXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60",
        sounds: five,
    },
    {
      title: "six",
      polish: "sześć",
      image:
        "https://images.unsplash.com/photo-1484335629320-0e089b87a106?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=658&q=80",
        sounds: six,
    },
    {
      title: "seven",
      polish: "siedem",
      image:
        "https://images.unsplash.com/photo-1571577275698-54f36820ee9b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
        sounds: seven,
    },
    {
      title: "eight",
      polish: "osiem",
      image:
        "https://images.unsplash.com/photo-1571664638276-b3e6b70499e6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
        sounds: eight,
    },
    {
        title: "nine",
        polish: "dziewięć",
        image:
          "https://images.unsplash.com/photo-1590160851422-3973baee2331?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=564&q=80",
          sounds: nine,
      },
      {
        title: "ten",
        polish: "dziesięć",
        image:
          "https://images.unsplash.com/photo-1522448023466-b1c85da46df0?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=750&q=80",
          sounds: ten,
      },
  ];
